const Divider = ({ className }) => (
    <div className={`bg-gray-300 h-px w-full ${className}`}></div>
)

export default Divider
